// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.selWidth[data-v-47efda6c] {\r\n  width: 350px;\n}\n[data-v-47efda6c] .dialog-footer-inner {\r\n  padding-top: 0 !important;\n}\n[data-v-47efda6c] [role='dialog'] .el-message-box__content {\r\n  padding: 30px 24px 20px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
